<template>
  <div class="register-page">
    <div class="register-container">
      <div class="register-title">
        <h1 class="title">{{ t('会員登録') }}</h1>
      </div>
      <MemberSave />
      <div class="login-link">
        <span>{{ t('アカウントをお持ちの方は') }}</span>
        <router-link to="/login">{{ t('ログイン') }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import MemberSave from '@/components/organisms/Login/MemberSave.vue';
import t from '@/plugins/i18n';

export default {
  name: 'UserRegisterPage',
  mixins: [t],
  components: {
    MemberSave,
  },
};
</script>

<style lang="scss" scoped>
.register-page {
  display: flex;
  justify-content: center;
  padding: 40px 16px 0px 16px;

  .register-title {
    text-align: center;
    margin-bottom: 25px;
    .title {
      font-size: 24px;
      font-weight: bold;
    }
  }

  .register-container {
    width: 600px;
    max-width: 100%;
  }

  .login-link {
    text-align: center;
    margin-top: 50px;
    font-size: 14px;
    a {
      color: #2fa7d7 !important;
      text-decoration: underline;
      font-weight: normal;
      margin-left: 4px;
      transition: 0.3s;
      &:hover {
        opacity: 0.8;
      }
    }
  }
}

@media screen and (max-width: $tabletWidth) {
  .register-page {
    padding: 20px 10px;
  }
}
</style>
